// angular
import { AfterViewInit, Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CoreService } from '../../core/core.service';
import { AppService } from '../../app.service';

// others
import { MePaymentService } from './me-payment.service';
import { AuthService } from '../../core/auth.service';

@Component({
    selector: 'me-payment',
    templateUrl: './me-payment.component.html',
    styleUrls: ['./me-payment.component.scss'],
    providers: [MePaymentService]
})

export class MePaymentComponent implements OnInit {
    registerSuccess = false;
    errorMessage = '';
    verifyToken = '';

    constructor(
        public mePaymentService: MePaymentService,
        public route : ActivatedRoute,
        public router: Router,
        public coreService : CoreService,
        public appService: AppService,
        public authService : AuthService
    ) {
    }

    ngOnInit() {
        
    }
}
